var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 18.9844V1.26562C26.25 0.564258 25.6648 0 24.9375 0H7C4.10156 0 1.75 2.26758 1.75 5.0625V21.9375C1.75 24.7324 4.10156 27 7 27H24.9375C25.6648 27 26.25 26.4357 26.25 25.7344V24.8906C26.25 24.4951 26.0586 24.1365 25.7633 23.9045C25.5336 23.0924 25.5336 20.7773 25.7633 19.9652C26.0586 19.7385 26.25 19.3799 26.25 18.9844ZM8.75 7.06641C8.75 6.89238 8.89766 6.75 9.07812 6.75H20.6719C20.8523 6.75 21 6.89238 21 7.06641V8.12109C21 8.29512 20.8523 8.4375 20.6719 8.4375H9.07812C8.89766 8.4375 8.75 8.29512 8.75 8.12109V7.06641ZM8.75 10.4414C8.75 10.2674 8.89766 10.125 9.07812 10.125H20.6719C20.8523 10.125 21 10.2674 21 10.4414V11.4961C21 11.6701 20.8523 11.8125 20.6719 11.8125H9.07812C8.89766 11.8125 8.75 11.6701 8.75 11.4961V10.4414ZM22.6078 23.625H7C6.03203 23.625 5.25 22.8709 5.25 21.9375C5.25 21.0094 6.0375 20.25 7 20.25H22.6078C22.5039 21.1518 22.5039 22.7232 22.6078 23.625Z",
    fill: "#3B7DDD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.9e25da4fd5756c350e566a2ad9f479f0.svg";
export { ForwardRef as ReactComponent };